// CarouselItem.js
import React from 'react';
import '../css/Autoplaycarousel.css';

const CarouselItem = ({ imgUrl, imgTitle, imgHeading }) => {
  return (
    <div className="carousel-card flex flex-col font-roboto font-bold text-[20px]">
      <img src={imgUrl} alt={imgTitle} />
      <h2>{imgHeading}</h2>
    </div>
  );
};

export default CarouselItem;
